/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type WorkOSDomainVerificationIntentOptions = {
  /**
   * Domain name to verify.
   */
  domainName?: string | undefined;
};

/** @internal */
export type WorkOSDomainVerificationIntentOptions$Outbound = {
  domain_name?: string | undefined;
};

/** @internal */
export const WorkOSDomainVerificationIntentOptions$outboundSchema:
  z.ZodMiniType<
    WorkOSDomainVerificationIntentOptions$Outbound,
    WorkOSDomainVerificationIntentOptions
  > = z.pipe(
    z.object({
      domainName: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        domainName: "domain_name",
      });
    }),
  );

export function workOSDomainVerificationIntentOptionsToJSON(
  workOSDomainVerificationIntentOptions: WorkOSDomainVerificationIntentOptions,
): string {
  return JSON.stringify(
    WorkOSDomainVerificationIntentOptions$outboundSchema.parse(
      workOSDomainVerificationIntentOptions,
    ),
  );
}
